import { Box } from '@mui/material';

import type { SpotHistoryTableColumnType } from '@/types/markets';

import DataRow from './DataRow';
import type { DisplayRow, VirtualCell } from './types';

type Props = {
  columns: SpotHistoryTableColumnType[];
  displayRows: DisplayRow[];
  virtualColumns: VirtualCell[];
  virtualRows: VirtualCell[];
  bodyHeight: number;
  totalWidth: number;
};

const TableBody = ({
  columns,
  displayRows,
  virtualColumns,
  virtualRows,
  bodyHeight,
  totalWidth
}: Props) => (
  <Box
    role='rowgroup'
    sx={{
      height: bodyHeight,
      position: 'relative',
      width: totalWidth
    }}
  >
    {virtualRows.map(virtualRow => (
      <DataRow
        key={`${displayRows[virtualRow.index].date}-${virtualRow.index}`}
        row={displayRows[virtualRow.index]}
        rowIndex={virtualRow.index}
        virtualRow={virtualRow}
        virtualColumns={virtualColumns}
        columns={columns}
        totalWidth={totalWidth}
      />
    ))}
  </Box>
);

export default TableBody;
